import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { slideInFade, fadeIn } from "../Animations.js";

const animations = {
    slideInFade,
    fadeIn
};

export const Icon = props => <I {...props} className={`fa ${props.icon}`} aria-hidden="true" />;

const I = styled.i`
    color: ${props => props.theme[props.colour] || props.colour};
    cursor: ${props => props.cursor || "pointer"};
    font-size: ${props => props.size || "inherit"} !important;
    margin: ${props => props.margin || "0"};
    padding: ${props => props.padding || "0"};

    &:hover {
        animation: ${props => (props.animation ? animations[props.animation] || "none" : "none")}
            0.3s forwards;

        @media (prefers-reduced-motion) {
            animation: none;
        }
    }
`;

Icon.propTypes = {
    colour: PropTypes.string,
    icon: PropTypes.string,
    size: PropTypes.string,
    padding: PropTypes.string
};
